import {Button, Flex, Popconfirm} from 'antd';
import React from 'react';

import {ReactComponent as Delete} from '../../../assets/icons/deleteIcon.svg';
import {ReactComponent as Edit} from '../../../assets/icons/editIcon.svg';
import type {PCFRecord} from '../../../services/interface/pcfTypes';
import usePlatformStore from '../../../store/platformStore/platformStore';
import {shouldBlockReadOnly} from '../../../utils/SubscriptionHelper';

const actionButtonStyle = {marginRight: '20px', backgroundColor: '#F5FBF3'};

const PCFStudyActions: React.FC<{
  record: PCFRecord;
  onEdit: (record: PCFRecord) => void;
  onDelete: (id: string) => void;
  isLoading?: boolean;
}> = ({record, onEdit, onDelete, isLoading = false}) => {
  const recordId = record._id ?? '';

  if (shouldBlockReadOnly()) {
    return (
      <Flex align="center" justify="flex-start" style={{width: 'fit-content'}}>
        <Button
          onClick={() => {
            usePlatformStore.getState().setOpenOnFreeTrialMessageModel(true);
          }}
          shape="circle"
          type="link"
          style={actionButtonStyle}
          icon={<Edit />}
        />
        <Button
          shape="circle"
          type="link"
          onClick={() => {
            usePlatformStore.getState().setOpenOnFreeTrialMessageModel(true);
          }}
          style={actionButtonStyle}
          icon={<Delete />}
        />
      </Flex>
    );
  }

  return (
    <Flex align="center" justify="flex-start" style={{width: 'fit-content'}}>
      <Button
        onClick={() => {
          onEdit(record);
        }}
        shape="circle"
        type="link"
        disabled={isLoading}
        loading={isLoading}
        style={actionButtonStyle}
        icon={<Edit />}
      />
      <Popconfirm
        title="Sure to delete?"
        onConfirm={() => {
          if (recordId) {
            onDelete(recordId);
          }
        }}
      >
        <Button
          shape="circle"
          type="link"
          style={actionButtonStyle}
          icon={<Delete />}
        />
      </Popconfirm>
    </Flex>
  );
};

export default PCFStudyActions;
